import { render, staticRenderFns } from "./InforpointsLayoutsDisplays.vue?vue&type=template&id=00de3d2c&scoped=true"
import script from "./InforpointsLayoutsDisplays.vue?vue&type=script&lang=js"
export * from "./InforpointsLayoutsDisplays.vue?vue&type=script&lang=js"
import style0 from "./InforpointsLayoutsDisplays.vue?vue&type=style&index=0&id=00de3d2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00de3d2c",
  null
  
)

export default component.exports